import { SystemField } from "./system-field";

export class ApiRoute extends SystemField { 
    name?:string;
    url?:string;
    description?:string;
    is_active?:number;
}
